import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useStore } from '../../state/zustand-store';
import { useMemo } from 'react';

export function StripeProvider({
  children,
  stripePublicKey,
}: {
  children: React.ReactNode;
  stripePublicKey: string;
}) {
  const { colorMode } = useStore();

  const stripePromise = useMemo(
    () => loadStripe(stripePublicKey),
    [stripePublicKey]
  );

  const appearance = {
    theme: colorMode === 'light' ? ('stripe' as const) : ('night' as const),
    variables: {
      //   colorPrimary: theme.palette.primary.main,
    },
  };

  const options = {
    mode: 'setup' as const,
    amount: 0,
    currency: 'usd',
    appearance,
    payment_method_types: ['card', 'us_bank_account'],
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
}
